import React from "react";
import WeatherIcon from "./WeatherIcon";
import './WeatherForecastDay.css';

export default function WeatherForecastDay(props) {
  function maxTemperature() {
    let temperature = Math.round(props.data.temp.max);
    return `${temperature}°`;
  }

  function minTemperature() {
    let temperature = Math.round(props.data.temp.min);
    return `${temperature}°`;
  }

  function day() {
    let date = new Date(props.data.dt * 1000);
    let day = date.getDay();

    let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    return days[day];
  }

  return (
    <div className="weatherForecast-block">
      <div className="WeatherForecast-day">{day()}</div>
      <div className="iconForecast">
              <WeatherIcon code={props.data.weather[0].icon} size={55}  />

      </div>
      <div className="row WeatherForecast-temperatures d-flex justify-content-sm-center w-100 ">
        <div className="col-3"><span className="WeatherForecast-temperature-max">{maxTemperature()} </span></div>
        <div className="col-3"><span className="WeatherForecast-temperature-min"> {minTemperature()} </span></div>


      </div>
    
    </div>
  );
}